import { useContext, useEffect, useMemo, useState } from 'react';
import { Context } from '../..';
import '../../pages/Bricks/brickstyles.css'
import search_icon from '../../static/admin_icons/magnifier.svg'
import DeleteModal from '../Modals/DeleteModal';
import { Link } from 'react-router-dom';
import { LOCAL_PHOTO_API_IP } from '../../utils/consts';
import { fetchAll } from '../../http/brickAPI';


function BricksFetch(props) {
    const [allMixed,setAllMixed] = useState([])
    const {bricks} = useContext(Context)
    const [brickId, setBrickId] = useState(null)
    const [brickName, setBrickName] = useState('')
    const [searchText,setSearchText] = useState('')
    const [showDelete,setShowDelete] = useState(false)

    useEffect(() => {
        fetchAll().then(data =>{
            bricks.setBricks(data)
            if(data.bricks && data.bricks.rows){
                setAllMixed(data.bricks.rows)
            }
        })
    },[bricks])
    const allProduct = useMemo(()=> [...allMixed], [allMixed])
    const filteredBricks = allProduct.filter(brick =>{
        return brick.name.toLowerCase().includes(searchText.toLocaleLowerCase())
    })
    return (
        <div style={{marginTop:'25%'}}>
            <div className='search-box'>
                <search>
                    <form method="get">
                        <input 
                        type='search'
                        name='search-text'
                        placeholder='Введите цвет'
                        onChange={(e) => setSearchText(e.target.value)}
                        />
                        <label for='search-text'>
                            <img 
                                src={search_icon} 
                                alt='search'
                                className='search__img'/>
                        </label>
                  </form>
            </search> 
            </div>
        <div className='centered' style={{flexDirection:'row',flexWrap:'wrap',justifyContent:'start'}}>
            {filteredBricks.map((brick)=>(
                <div className='brick-card-admin' key={brick.name}>
                    <ul>
                        <li>
                            <p>{brick.name}</p>
                            </li>
                        <li>
                            { brick.image ? <img src={LOCAL_PHOTO_API_IP + brick.image} alt='brick-photo'/> : <img alt='no-photo'/>}
                        </li>
                            <li><button id='delete-btn' onClick={e => {
                                setBrickId(brick.id)
                                setBrickName(brick.name)
                                setShowDelete(true)
                                }
                                }>Удалить</button></li>
                                <li>
                                    <Link to={`/update-brick/${brick.id}`}>
                                        <button id='update-btn'>Изменить</button>
                                    </Link>
                                </li>
                    </ul> 
                    
                    </div>
            ))
            
            }

        </div>
            <DeleteModal 
            onHide={() => setShowDelete(false)} 
            show={showDelete}
            name={`Вы точно хотите удалить "${brickName} ID: ${brickId}"?`}
            id={brickId}/>
        </div>
    );
}

export default BricksFetch;